export default "__VITE_ASSET__OF3jIOXs__"